import { createFileRoute } from "@tanstack/react-router";
import AISummarizeLecturesGuide from "@/pages/resources/AISummarizeLecturesGuide";

export const Route = createFileRoute("/learn/ai-summarize-lectures")({
  head: () => ({
    meta: [
        {
            "title": "How to Summarize Lecture Notes with AI | System Atlas"
        },
        {
            "name": "description",
            "content": "Turn dense lecture notes and PDFs into clear, structured summaries with AI. Step-by-step guide with best practices for students."
        },
        {
            "property": "og:title",
            "content": "How to Summarize Lecture Notes with AI | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Turn dense lecture notes and PDFs into clear, structured summaries with AI. Step-by-step guide with best practices for students."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/ai-summarize-lectures"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "How to Summarize Lecture Notes with AI | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Turn dense lecture notes and PDFs into clear, structured summaries with AI. Step-by-step guide with best practices for students."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/ai-summarize-lectures"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/ai-summarize-lectures"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/ai-summarize-lectures"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/ai-summarize-lectures"
        }
    ],
  }),
  component: AISummarizeLecturesGuide,
});
